import {
  Button,
  Card,
  CardActions,
  CardContent,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles({
  root: {
    width: "30%",
    display: "inline-block",
    margin: "1.5%",
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  title: {
    fontSize: 14,
    color: "#24135f !important",
  },
  pos: {
    marginBottom: 12,
  },
  boton: {
    color: "#24135f",
  },
});

const Publicaciones = () => {
  const classes = useStyles();

  return (
    <>
      <h2 className="sectionTitle">
        Últimas publicaciones de la Unidad Estadística
      </h2>
      <Card className="cardPublicaciones">
        <CardContent>
          <Typography className={classes.title}></Typography>
          <Typography variant="h5" component="h2" className={classes.title}>
            Título de la publicación
          </Typography>
          <Typography className={classes.pos}>
            Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque
            mattis lectus, nec fames mollis netus cum pharetra taciti porta
            donec, feugiat cras tincidunt tellus semper facilisi libero mi
            tristique. Euismod dui integer lectus felis fermentum leo id nam,
            quisque aliquet ullamcorper curae eget proin mus, vulputate pretium
            hendrerit posuere at blandit rhoncus. Ac urna donec imperdiet
            tincidunt augue maecenas aenean gravida, euismod ut fringilla
            sociosqu nisl placerat nunc congue, hendrerit inceptos velit feugiat
            proin platea at.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" className={classes.boton}>
            Ir a la publicación
          </Button>
        </CardActions>
      </Card>
      <Card className="cardPublicaciones">
        <CardContent>
          <Typography className={classes.title}></Typography>
          <Typography variant="h5" component="h2" className={classes.title}>
            Título de la publicación
          </Typography>
          <Typography className={classes.pos}>
            Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque
            mattis lectus, nec fames mollis netus cum pharetra taciti porta
            donec, feugiat cras tincidunt tellus semper facilisi libero mi
            tristique. Euismod dui integer lectus felis fermentum leo id nam,
            quisque aliquet ullamcorper curae eget proin mus, vulputate pretium
            hendrerit posuere at blandit rhoncus. Ac urna donec imperdiet
            tincidunt augue maecenas aenean gravida, euismod ut fringilla
            sociosqu nisl placerat nunc congue, hendrerit inceptos velit feugiat
            proin platea at.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" className={classes.boton}>
            Ir a la publicación
          </Button>
        </CardActions>
      </Card>
      <Card className="cardPublicaciones">
        <CardContent>
          <Typography className={classes.title}></Typography>
          <Typography variant="h5" component="h2" className={classes.title}>
            Título de la publicación
          </Typography>
          <Typography className={classes.pos}>
            Lorem ipsum dolor sit amet consectetur adipiscing elit pellentesque
            mattis lectus, nec fames mollis netus cum pharetra taciti porta
            donec, feugiat cras tincidunt tellus semper facilisi libero mi
            tristique. Euismod dui integer lectus felis fermentum leo id nam,
            quisque aliquet ullamcorper curae eget proin mus, vulputate pretium
            hendrerit posuere at blandit rhoncus. Ac urna donec imperdiet
            tincidunt augue maecenas aenean gravida, euismod ut fringilla
            sociosqu nisl placerat nunc congue, hendrerit inceptos velit feugiat
            proin platea at.
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" className={classes.boton}>
            Ir a la publicación
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default Publicaciones;
